export enum ImageCachingLoadingType {
  WaitForAll = 'waitForAll',
  WaitForFirst = 'waitForFirst',
  Background = 'background',
}
